import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * Decorator method to extract `theme` from context and inject that prop into `ChildComponent`.
 * @param ChildComponent [ReactElement] The Child Component that has the injected with the `theme` property.
 *
 */
const theme = (ChildComponent) => {
  return class ThemedComponent extends Component {
    static contextTypes = {
      theme: PropTypes.object,
      themeProvider: PropTypes.func,
      updateTheme: PropTypes.func,
    };

    render() {
      const {theme, themeProvider, updateTheme} = this.context;

      return (
        <ChildComponent {...this.props} theme={{...theme}} themeProvider={themeProvider} updateTheme={updateTheme} />
      );
    }
  };
};

export default theme;
